export const fetchSensorData = async ({
  sensors,
  vehicleId,
  isoDateStartCurrent,
  isoDateFinishCurrent,
  fetchSensorValues,
}) => {
  try {
    let response;

    if (sensors.length > 1) {
      response = await fetchSensorValues({
        params: {
          'vehicleId.equals': vehicleId,
          'sensorId.in': sensors.map((s) => s.sensorTypeId).join(','),
          'createdDate.greaterThanOrEqual': isoDateStartCurrent,
          'createdDate.lessThan': isoDateFinishCurrent,
          page: 0,
          size: 200000,
          sort: 'createdDate,asc',
        },
      }).unwrap();

      const grouped = new Map();

      response.forEach((item) => {
        const key = item.sensorValueType;
        if (!grouped.has(key)) grouped.set(key, []);
        grouped.get(key).push(item);
      });

      return grouped;
    }

    // один сенсор
    const sensor = sensors[0];

    response = await fetchSensorValues({
      params: {
        'vehicleId.equals': vehicleId,
        'sensorId.equals': sensor.sensorTypeId,
        'createdDate.greaterThanOrEqual': isoDateStartCurrent,
        'createdDate.lessThan': isoDateFinishCurrent,
        page: 0,
        size: 200000,
        sort: 'createdDate,asc',
      },
    }).unwrap();

    return new Map([[sensor.sensorTypeId, response]]);
  } catch (e) {
    console.error('Ошибка загрузки сенсоров', e);
    return new Map();
  }
};

export default fetchSensorData;
